import { ProformaInvoiceFormViewMode } from '../../../../../teams/components/forms/ProformaInvoiceForm/ProformaInvoiceForm.types';
import { InvoiceStatuses } from '../../../../invoicesTypes';

import { useInvoiceItemsViewContext } from '../useInvoiceItemsViewContext';

interface InvoiceItemsViewColumnsOptions {
  readonly?: boolean;
}

function useInvoiceItemsViewColumns({
  readonly
}: InvoiceItemsViewColumnsOptions = {}) {
  const { invoice, watchFields } = useInvoiceItemsViewContext();

  const showItemsCol =
    watchFields.watchViewMode === ProformaInvoiceFormViewMode.INVOICES;

  const showTasksCol =
    watchFields.watchViewMode === ProformaInvoiceFormViewMode.TASKS;

  const showProjectsCol =
    watchFields.watchViewMode === ProformaInvoiceFormViewMode.PROJECTS;

  const showGroupsCol =
    watchFields.watchViewMode === ProformaInvoiceFormViewMode.GROUPS;

  const showCategoriesCol =
    watchFields.watchViewMode === ProformaInvoiceFormViewMode.CATEGORIES;

  const showOwnerCol = showProjectsCol || showTasksCol;

  const showQtyCol = showItemsCol;

  const showCheckboxCol =
    invoice?.status === InvoiceStatuses.DRAFT && !readonly;

  return {
    showItemsCol,
    showTasksCol,
    showGroupsCol,
    showProjectsCol,
    showCategoriesCol,
    showOwnerCol,
    showQtyCol,
    showCheckboxCol
  };
}

export default useInvoiceItemsViewColumns;
